import { render, staticRenderFns } from "./PlatformSelector.vue?vue&type=template&id=0e516ab8"
import script from "./PlatformSelector.vue?vue&type=script&lang=js"
export * from "./PlatformSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports